import http from "./apiServices"
import { formatPayloadToParams } from "@utils/formatter"

export const getBCSyncLogs = (payload = {}) => {
  let params = formatPayloadToParams(payload, ["type", "status", "keyword", "sort", "order"])
  return http.get("bc-sync-logs", { params })
}

export const getBCSyncLogById = (id) => {
  return http.get(`bc-sync-logs/${id}`)
}

export const resyncBCSyncLogById = (id) => {
  return http.put(`bc-sync-logs/${id}/resync`)
}

export const cancelBCSyncLogById = (id) => {
  return http.put(`bc-sync-logs/${id}/cancel`)
}
